import axios from 'axios'
import { memberCalls2Url } from '@helpers'
import type { TProductsResponse } from '../types/product.types'

const getProducts = ({
    countryCode3Alpha,
    userStatus,
    allow = 'shop',
    warehouse = 'Main'
}: {
    countryCode3Alpha: string
    userStatus: string
    allow?: string
    /** Stock warehouse configured by the selected shipping option. */
    warehouse?: string
}) => {
    // Omit status= entirely when anonymous (no userStatus); once authed the
    // rank-derived userStatus is sent.
    const statusParam = userStatus ? `&status=${userStatus}` : ''
    const url = memberCalls2Url({
        path: `/products-v2/publish/${countryCode3Alpha}?allow=${allow}${statusParam}&warehouse=${warehouse}`
    })

    return axios.get<TProductsResponse>(url)
}

export const productsApi = {
    getProducts
}
